import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/telegram': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM369.8 177.9c3.6-16.8-6.1-23.5-17.2-19.5l-239.1 92.2c-16.4 6.4-16.1 15.5-2.8 19.7l61.2 19.1 142-89.4c6.6-4.4 12.7-1.9 7.7 2.5l-114.9 103.8-4.4 63.1c6.4 0 9.2-2.8 12.5-6.1l29.9-28.8 62 45.7c11.3 6.4 19.4 3.1 22.4-10.5z'
      }
    ]
  }
})
